import { AfterViewChecked, AfterViewInit, Component, ElementRef, Input, ViewChild, Renderer2 } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'app-marquee',
  templateUrl: './marquee.component.html',
  styleUrls: ['./marquee.component.scss']
})
export class MarqueeComponent implements AfterViewInit, AfterViewChecked {

  @Input() playToggle$: Observable<boolean> = new BehaviorSubject<boolean>(true);
  @Input() cssClass: string = '';

  isPlaying: boolean = false;
  animationSpeed: number = 50;
  minSpeed: number = 10;
  lastOffsetWidth: number = 0;
  lastScrollWidth: number = 0;
  initialized = false;
  @ViewChild('container') containerRef!: ElementRef;
  @ViewChild('content') contentRef!: ElementRef;
  constructor(private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    setTimeout(() => this.checkAndStartMarquee(), 0);
  }
  ngAfterViewChecked(): void {
    if (!this.initialized && this.contentRef?.nativeElement.scrollWidth > 0) {
      this.initialized = true;
      this.checkAndStartMarquee();
    }
  }
  checkAndStartMarquee(): void {
    const offsetWidth = this.containerRef.nativeElement.offsetWidth;
    const scrollWidth = this.contentRef.nativeElement.scrollWidth ;

    // Avoid repeating logic unless dimensions change
    if (offsetWidth === this.lastOffsetWidth && scrollWidth === this.lastScrollWidth) {
      return;
    }

    this.lastOffsetWidth = offsetWidth;
    this.lastScrollWidth = scrollWidth;
    
    if(this.initialized){
      if (scrollWidth > offsetWidth) {
      
        const baseSpeed = 70; // pixels per second
        let dynamicSpeed = scrollWidth / baseSpeed;

        if (dynamicSpeed < 35) {
          dynamicSpeed = 35;
        }
       
        this.renderer.setStyle(this.contentRef.nativeElement, 'animation-play-state', 'running'); // Note kebab-case
        this.renderer.setStyle(this.contentRef.nativeElement, 
          'animation-duration', `${dynamicSpeed}s`);
        this.isPlaying = true;
      
      } else {
        this.contentRef.nativeElement.style.animation = 'none';
        this.isPlaying = false;
        
      }
    }
  }
}